// extracted by mini-css-extract-plugin
export default {"path":"UpIcon_path__Ibr4n"};